import React, { Component } from "react";
import BuscaPorFaturas from "./tela-busca-por-faturas/busca-faturas";
import BuscaPorStatus from "./tela-busca-por-status/busca-status";
import NotasFiscais from "./tela-notas-fiscais/notas-fiscais";
import TrackingLabChoose from "./financeiro-inputs/tracking-labchoose";
import TrackingInputCNPJ from "./financeiro-inputs/tracking-input-cnpj";
import MenuHorizontal from "../components/menu/menu-horizontal/index.js";
import Back from "../main/back";
import ResumoLateral from "../components/resumo-lateral";
import { Container } from "@material-ui/core";
import { getRedes } from "../Functions/redes/getRedes";
import Moment from "moment";
import { Redirect } from "react-router-dom";
import "./financeiro.css";
import AppContext from "../appContext";
import { redirectPage } from "../components/utils/redirectpage";
import { Relacionamento } from "../Functions/gestao-laboratorios/relacionamento";
import Swal from "sweetalert2";
import CnpjUtils from "../shared/utils/CnpjUtils";

class Financeiro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_option: 1,
      redeOticaAux: false,
      menuOptions: [],
      listaPapeis: [],
      laboratorios: [],
      laboratorio: "",
      cnpj_number: "",
      redes: "",
      cnpj_number_aux: "",
      detailOrder: "",
      laboratorio_cnpj: "",
      laboratorio_nome: "",
      campoCnpjLiberado: false,
      input_cnpj: false,
      labError: "",
    };
    this.handleChangeProps = this.handleChangeProps.bind(this);
    this.setLabData = this.setLabData.bind(this);
    this.handleChangeCnpj = this.handleChangeCnpj.bind(this);
    if (sessionStorage.getItem("token") !== null) {
      Financeiro.contextType = AppContext;

      let role = false;
      role = Financeiro.contextType._currentValue.userSession.modulos.find(element => element === "Financeiro");
      if (!role) {
        this.state = { redirect: true };
      }
    } else {
      this.state = { redirectL: true };
    }
  }
  componentDidMount() {
    redirectPage(this.context.userSession, "/financeiro");
    if (sessionStorage.getItem("token")) {
      if (this.context.userSession.redeOticas) {
        this.setState({ redeOticaAux: false });
      }

      // integração no OEC para ver todos os papéis que tem marcação de multiplas óticas
      const papeis = [];
      const requestOptions = {
        method: "GET",
      };

      fetch(process.env.REACT_APP_LABS_API + "get_multioptics_roles.php", requestOptions)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.status === "sucesso") {
            if (json.items) {
              for (var i = 0; i < json.items.length; i++) {
                var papel = {
                  nome: json.items[i].recordName,
                };
                papeis.push(papel);
              }
            }
            this.setState({ listaPapeis: papeis });

            var user_role = this.context.userSession.papel;
            var roles = JSON.stringify(this.state.listaPapeis);

            // compara os papéis de multiplas oticas do OEC com o papel do usuário logado, se ele estiver na lista, o campo CNPJ aparece na tela
            if (roles && roles.match(user_role)) {
              this.setState({
                input_cnpj: true,
              });
            }
          }
        });
    } else {
      this.setState({ redirectL: true });
    }
    if (this.context.userSession.papelCategoria === "ESSILOR") {
      this.setState({ redeOticaAux: true });
    }
    if (this.context.userSession.papelCategoria === "LABORATORIO") {
      this.setState({ redeOticaAux: true, input_cnpj: true, campoCnpjLiberado: true });
    }
  }

  borderColor(idElement, color = "#f70017") {
    //#f70017  #B5B5B5
    if (typeof idElement === "object") {
      idElement.map(el => {
        if (document.getElementById(el)) {
          return (document.getElementById(el).style.boxShadow = `0 0 0 1px ${color}`);
        }
        return null;
      });
    } else {
      document.getElementById(idElement).style.boxShadow = `0 0 0 1px ${color}`;
    }
  }

  setLabData(e, label, detailOrder, params) {
    if (e.name === "lab") {
      this.handleChangeProps(e);
    }

    if (e.value) {
      if (this.context.userSession.papelCategoria === "LABORATORIO") {
        if (e.value === this.context.userSession.conta) {
          this.setState({ campoCnpjLiberado: true, cnpj_number: this.state.cnpj_number_aux });
        } else {
          this.setState({ campoCnpjLiberado: false, cnpj_number_aux: this.state.cnpj_number, cnpj_number: "" });
        }
      } else {
        this.setState({ campoCnpjLiberado: true });
      }

      if (this.context.userSession.redeOticas) {
        this.context.showLoading("Buscando...");
        this.listarRedesOticas(e.value);
      }
    }

    this.setState({
      labError: "",
      lab: {
        dados: params,
        laboratorio_nome: label || "",
        laboratorio_cnpj: e.value || "",
        detailOrder: detailOrder || "",
      },
    });
  }

  handleChangeCnpj(e) {
    this.handleChangeProps(e.target);
    this.borderColor("cnpj_number", "#B5B5B5");
  }

  obterOtica(laboratorio) {
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cnpj: this.context.userSession.conta }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions1)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (this.context.userSession.redeOticas) {
          this.context.showLoading("Buscando...");
          this.setState({ oticaPrincipal: json.nome, cnpjPrincipal: json.cnpj }, this.listarRedesOticas(laboratorio));
        } else {
          const redes = [];
          var rede = {
            label: json.nome,
            value: json.cnpj,
          };
          redes.push(rede);
          this.setState({ redes: redes, cnpjPrincipal: json.cnpj });
        }
      });
  }

  handleChange(e) {
    let state = {};
    const name = e.target.getAttribute("name");
    const { value } = e.target;

    //valida o formato do numero do pedido laboratorio
    //pedido otica pode ser qualquer coisa, então não tem validação
    if (e.target.getAttribute("name") === "pedido_laboratorio") {
      if (!Number(value) && value !== "") {
        return;
      }
    }
    //seta o numero do pedido no state
    state[name] = value ? value : "";
    this.setState({ status: value }, () => {
      if (value === "PENDENTE") {
        this.setState({ statusMessage: 'O resultado da busca com status "Pendente" contempla as parcelas pendentes de pagamento, incluindo as já vencidas.' });
      } else if (value === "BAIXADO") {
        this.setState({ statusMessage: 'O resultado da busca com status "Pago" contempla as parcelas dos últimos 120 dias.' });
      } else if (value === "AVENCER") {
        this.setState({ statusMessage: 'O resultado da busca com status "A vencer" contempla as parcelas vencendo em 15 dias.' });
      }
    });
    this.setState(state);
    this.borderColor(name, "#B5B5B5");
  }

  handleChange_data_inicio = date => {
    //trata o formato da data
    const diaInicio = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_inicio: diaInicio,
      //seta data para exibir no input date
      dia_inicio: date,
    });
  };

  handleChange_data_fim = date => {
    //trata o formato da data
    const diaFim = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_fim: diaFim,
      //seta data para exibir no input date
      dia_fim: date,
    });
  };

  changeState() {
    this.borderColor(["lab", "cnpj_number"], "#B5B5B5");
    this.borderColor(["data_inicio", "data_fim", "pedido_otica"], "#FFF");
    this.setState({
      loading: true,
      data_tabela: [],
      resposta_tabela: false,
      classOpacity: "Opacity",
    });

    let valido = this.validarCampos();
    if (valido) {
      this.context.showLoading("Buscando...");
      this.integraPedido();
    }
  }

  openSummary(e) {
    this.setState({ [e.target.id]: e.target.value }, () => {
      if (this.state.open) {
        this.setState({ open: "", arrow: "" });
      } else {
        this.setState({ open: "show-summary", arrow: "active-arrow" });
      }
    });
  }

  checkHealth() {
    const requestOptions = {
      method: "GET",
      headers: {
        laboratorio: this.state.laboratorio,
      },
    };

    fetch(process.env.REACT_APP_ESSILOR_API + "gestao-produtos-laboratorio/v1/health", requestOptions).then(response => {
      this.setState({ statusProduct: response.status }, () => {
        fetch(process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/health", requestOptions).then(response => {
          this.setState({ statusOrder: response.status }, async () => {
            if (this.state.statusProduct === 200 || this.state.statusOrder === 200) {
              // se passar no health o codigo ja busca as redes
              this.listarRedesOticas(this.state.laboratorio);
              return true;
            } else {
              this.context.hideLoading();
              Swal.fire({
                html: "O serviço está temporariamente indisponível para este laboratório.<br /> O time do Essilor Conecta já está atuando para resolver o problema.",
                width: "auto",
                icon: "warning",
                title: "Aviso",
                confirmButtonColor: "#00518b",
                customClass: {
                  confirmButton: "x-follow-order__filter-btn",
                },
              }).then(result => {
                if (result.value) {
                  this.setState({
                    redirect: false,
                  });
                }
              });

              return false;
            }
          });
        });
      });
    });
  }

  validarCampos() {
    if (!this.state.laboratorio_nome) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione um laboratório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("lab");
      return;
    } else if (this.context.userSession.redeOticas && this.state.redeOticaAux && !this.state.cnpj_number) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione uma ótica.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.state.input_cnpj && this.state.redeOticaAux && !this.state.cnpj_number && !this.context.userSession.redeOticas) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "O campo CNPJ é obrigatório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.state.status !== "PENDENTE" && this.state.status !== "BAIXADO" && this.state.status !== "AVENCER") {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Preencha o status da Parcela.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["status"]);
      return;
    }

    if (this.state.data_inicio === "" || this.state.data_fim === "") {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: " Por favor, informe um período válido para o seu pedido.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else if (this.state.data_inicio > this.state.data_fim) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Período da busca inválido: Data inicial maior que data final.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else {
      let ini = new Date(this.state.data_inicio);
      let fim = new Date(this.state.data_fim);
      let diff = (fim.getTime() - ini.getTime()) / 1000 / 3600 / 24;
      if (diff > 60) {
        this.setState({
          loading: false,
          classOpacity: "Nopacity",
        });
        this.context.hideLoading();
        Swal.fire({
          text: "O período de busca não pode ser superior a 60 dias.",
          title: "Aviso",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        this.borderColor(["data_inicio", "data_fim"]);
        return;
      }
    }
    return true;
  }

  async integraPedido() {
    if (this.context.userSession.papelCategoria === "LABORATORIO") {
      const oticaCnpj = CnpjUtils.cleanCnpj(this.state.cnpj_number);
      const labCnpj = this.state.laboratorio_cnpj;
      const relacionamento = await Relacionamento(labCnpj, oticaCnpj);
      if (relacionamento === false) {
        this.context.hideLoading();
        this.setState({ loading: false, classOpacity: "Nopacity" });
        Swal.fire({
          text: "A ótica informada não possui relacionamento com o laboratório.",
          title: "Aviso",
          icon: "warning",
          confirmButtonColor: "#00518b",
          confirmButtonText: "Ok",
        });
        return;
      }
    }

    var status = this.state.status !== "AVENCER" ? this.state.status : "PENDENTE";
    var table = [];
    const requestOptions = {
      method: "GET",
      headers: {
        access_token: sessionStorage.getItem("token"),
        client_id: localStorage.getItem("clientid"),
        laboratorio: this.state.laboratorio_cnpj,
        otica: CnpjUtils.cleanCnpj(this.state.cnpj_number),
      },
    };
    fetch(process.env.REACT_APP_ESSILOR_API + `gestao-financeira-cliente-laboratorio/v1/faturas?status=${status}`, requestOptions)
      .then(response => {
        return response.json();
      })
      .then(response => {
        let data = [];
        let today = new Date();
        let next15Days = new Date();
        next15Days.setDate(next15Days.getDate() + 15);

        if (this.state.status !== "AVENCER") {
          response.forEach(fatura => {
            let dataVencimento = new Date(fatura.dataVencimento);
            var statusFatura = fatura.status;
            if (dataVencimento >= today && dataVencimento <= next15Days) {
              statusFatura = "AVENCER";
            }
            data.push({
              codigo: fatura.codigo,
              parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
              nDocumento: fatura.numeroDocumento,
              dataEmissao: fatura.dataEmissao,
              dataVencimento: fatura.dataVencimento,
              valor: fatura.valor,
              valorAberto: fatura.valorAberto,
              status: statusFatura,
            });
          });
          data.sort((a, b) => {
            if (Moment(a.dataVencimento) < Moment(b.dataVencimento)) return -1;
            if (Moment(a.dataVencimento) > Moment(b.dataVencimento)) return 1;
            return 0;
          });
        } else {
          response.forEach(fatura => {
            let dataVencimento = new Date(fatura.dataVencimento);
            var statusFatura = fatura.status;
            if (dataVencimento >= today && dataVencimento <= next15Days) {
              statusFatura = "AVENCER";
              data.push({
                codigo: fatura.codigo,
                parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
                nDocumento: fatura.numeroDocumento,
                dataEmissao: fatura.dataEmissao,
                dataVencimento: fatura.dataVencimento,
                valor: fatura.valor,
                valorAberto: fatura.valorAberto,
                status: fatura.status,
              });
            }
            table.push({
              codigo: fatura.codigo,
              parcela: fatura.parcela.substring(0, 2) + "/" + fatura.parcela.substring(2),
              nDocumento: fatura.numeroDocumento,
              dataEmissao: fatura.dataEmissao,
              dataVencimento: fatura.dataVencimento,
              valor: fatura.valor,
              valorAberto: fatura.valorAberto,
              status: statusFatura,
            });
          });
          data.sort((a, b) => {
            if (Moment(a.dataVencimento) < Moment(b.dataVencimento)) return -1;
            if (Moment(a.dataVencimento) > Moment(b.dataVencimento)) return 1;
            return 0;
          });
        }
        this.setState({
          data_tabela: data,
          table: table,
          resposta_tabela: true,
          loading: false,
          classOpacity: "Nopacity",
        });
        this.context.hideLoading();
      })
      .catch(() => {
        this.setState({
          data_tabela: [],
          resposta_tabela: false,
          loading: false,
          classOpacity: "Nopacity",
        });
        this.context.hideLoading();
        //TK-083-000169 - Adicionado a mensagem abaixo em caso de falha na integração.
        Swal.fire({
          text: "Falha de comunicação com o laboratório. Tente novamente mais tarde.",
          title: "Aviso",
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
      });
  }

  listarRedesOticas = async laboratorio => {
    if (this.context.userSession.modulos.includes("Consulta Rede")) {
      const body = {
        usuario: this.context,
        laboratorio: laboratorio,
        consultaRede: this.context.userSession.modulos.includes("Consulta Rede"),
      };

      try {
        const result = await getRedes(body);
        if (result) {
          if (result.status !== 200) {
            this.setState({ cnpj_number_aux: this.state.cnpj_number, cnpj_number: "", redeOticaAux: false });
          } else if (result.status === 200) {
            this.setState({ redes: result.redes, redeOticaAux: true, cnpj_number: this.state.cnpj_number_aux });
          }
        }
      } catch (error) {
        console.error("Erro ao usar a função getRedes:", error.message);
      }
    } else {
      this.setState({ cnpj_number_aux: this.state.cnpj_number, cnpj_number: "" });
    }
    setTimeout(() => {
      this.context.hideLoading();
    }, 1000);
  };

  handleChangeOption(option) {
    if (option !== this.state.selected_option) {
      this.setState({
        selected_option: option,
      });
    }
  }

  handleChangeProps(param, tipo = null, valor = null) {
    if (param.name === "lab") {
      this.setState({ laboratorio: param.value }, () => {
        if (Boolean(param.value)) {
          this.checkHealth();
        }
      });
    } else if (tipo === "boolean") {
      this.setState({ [param]: valor });
    } else if (param.name === "cnpj_number") {
      this.setState({ cnpj_number: param.value });
    } else if (tipo === "laboratorios") {
      this.setState({ laboratorios: param });
    } else if (tipo === "dadosLab") {
      this.setState({ lab: param });
    } else if (param === "labError") {
      this.setState({ labError: valor });
    } else if (param === "detailOrder" || param === "laboratorio_cnpj" || param === "laboratorio_nome") {
      this.setState({ [param]: param });
    }
  }
  render() {
    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }

    if (this.state.redirectL) {
      return <Redirect to="/" />;
    }

    const labSelecionado = (this.state.laboratorios || []).find(item => item.value === this.state.laboratorio);
    const novosFiltrosFinanceiros = labSelecionado?.novosFiltrosFinanceiros === true;
    const containerSelectInput = this.state.redeOticaAux === true ? "col-md-5" : "col-md-5 mx-auto";
    const menuOptions = [
      {
        id: 1,
        label: "Faturas",
        component: (
          <BuscaPorFaturas
            redeOticaAux={this.state.redeOticaAux}
            input_cnpj={this.state.input_cnpj}
            handleChangeProps={this.handleChangeProps}
            statusOrder={this.state.statusOrder}
            statusProduct={this.state.statusProduct}
            listaPapeis={this.state.listaPapeis}
            cnpj_number={this.state.cnpj_number}
            cnpj_number_aux={this.state.cnpj_number_aux}
            laboratorio_dados={this.state.lab}
            novosFiltrosFinanceiros={novosFiltrosFinanceiros}
          />
        ),
      },
      {
        id: 2,
        label: "Busca por Status",
        component: (
          <BuscaPorStatus
            redeOticaAux={this.state.redeOticaAux}
            input_cnpj={this.state.input_cnpj}
            handleChangeProps={this.handleChangeProps}
            status={this.state.statusOrder}
            statusProduct={this.state.statusProduct}
            listaPapeis={this.state.listaPapeis}
            cnpj_number={this.state.cnpj_number}
            cnpj_number_aux={this.state.cnpj_number_aux}
            laboratorio_dados={this.state.lab}
            novosFiltrosFinanceiros={novosFiltrosFinanceiros}
          />
        ),
      },
    ];

    if (labSelecionado?.downloadNfs) {
      menuOptions.push({
        id: 3,
        label: "Notas Fiscais",
        component: (
          <NotasFiscais
            redeOticaAux={this.state.redeOticaAux}
            input_cnpj={this.state.input_cnpj}
            handleChangeProps={this.handleChangeProps}
            cnpj_number={this.state.cnpj_number}
            laboratorio_dados={this.state.lab}
          />
        ),
      });
    }

    return (
      <main className="main-financeiro">
        <div id="container-financeiro-page">
          <Back items={[{ label: 'Financeiro' }]} title="Financeiro" />
          <Container maxWidth="lg" disableGutters>
            <div className="title-container">
              <h1 className="main-title">Acompanhe sua movimentação</h1>
              <span className="title-shape"></span>
            </div>
            <div className="subtitle-container">
              <p className="subtitle">Acompanhe a movimentação financeira da sua empresa dentro dos laboratórios do grupo EssilorLuxottica.</p>
            </div>

            <div className="row d-flex justify-content-center">
              <div className={`col-xs-6 ${containerSelectInput}`}>
                <TrackingLabChoose
                  onChange={this.setLabData}
                  lab={this.state.laboratorio}
                  labs={this.state.laboratorios}
                  handleChangeProps={this.handleChangeProps}
                  error={this.state.labError}
                />
              </div>
              {this.state.input_cnpj && this.state.redeOticaAux && (
                <div className={`col-xs-6 ${containerSelectInput}`}>
                  <TrackingInputCNPJ
                    name="cnpj_number"
                    value={this.state.cnpj_number}
                    onChange={this.handleChangeCnpj}
                    disabled={!this.state.campoCnpjLiberado}
                    redes={this.state.redes}
                  />
                </div>
              )}
            </div>

            <div>
              <MenuHorizontal key={this.state.laboratorio} menuOptions={menuOptions} />
            </div>
          </Container>
        </div>

        <ResumoLateral
          logoTransparente={"image/modulos/Conecta_Financeiro_transparente.png"}
          lab={this.state?.lab?.dados}
          lab_phone={this.state.lab?.dados?.phone}
          lab_email={this.state.lab?.dados?.email}
          lab_site={this.state.lab?.dados?.site}
          lab_logo={this.state.lab?.dados?.logo}
        />
      </main>
    );
  }
}

export default Financeiro;
